export default __webpack_public_path__ + "static/media/icon-reports.2bd3b2b4.svg";